export enum TableContactFilter {
    ContactStatusFilter = 0,
}